module.exports = __webpack_public_path__ + "images/0655a86f.jpg";